import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { shopContext } from '../../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import { chatbotApi } from '../../../common/src';
import { toast } from 'react-toastify';
import moment from 'moment';

const WidgetPointOrderList = (props) => {
  const { loginId, history } = props;
  const [list, setList] = useState(null);
  //   const preText = props.childProps.state.prevMessage;
  //   const _prev = () => {
  //     props.childProps.actionProvider._categoryPrev(preText);
  //   };
  const _goHome = () => {
    props.childProps.actionProvider._home(-1);
  };
  const _more = () => {
    history.push('/mypage/4');
  };
  const _goMy = (orderCode) => {};
  const _getData = async () => {
    if (loginId === undefined || loginId === null || loginId === '') {
      toast.warn('로그인후 이용 가능한 서비스입니다.');
    } else {
      const result = await axios.post(chatbotApi + '/api/getPointOrderList', {
        userid: loginId,
      });
      //   //console.log(result);

      const intReturn = result.data.intReturn;
      //console.log(intReturn);
      //console.log(result.data.listData);
      if (intReturn === 0) {
        setList(result.data.listData);
      }
    }
  };
  const _addComma = (price) => {
    let returnString = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return returnString;
  };
  useEffect(() => {
    _getData();
  }, []);
  return (
    <>
      <div className="order-container">
        <div>
          <h1>포인트 구매 내역</h1>
        </div>
        <div className="order-info">
          <div>
            <table>
              <thead>
                <tr>
                  <th>상품명</th>
                  {/* <th>결제금액</th>
                  <th>구분</th> */}
                </tr>
              </thead>
              <tbody>
                {list ? (
                  list.map((item) => (
                    <tr>
                      <td>
                        <span>[주문번호: {item.orderCode}]</span>
                        <br />
                        {item.freePassName}
                        <br />
                        <em>결제 금액: {_addComma(item.freePassPrice)}</em>
                        <em>
                          결제일:{' '}
                          {moment(item.regDate).format('YYYY.MM.DD hh:mm')}
                        </em>
                        <div onClick={() => _goMy(item.orderCode)}>
                          바로가기
                        </div>
                      </td>
                      {/* <td>{item.sumPrice}</td>
                      <td>환불/취소</td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td>환불 가능한 결제내역이 존지하지 않습니다.</td>
                  </tr>
                )}
                <tr>
                  <div className="refund-info">
                    유상으로 충전한 포인트는 결제일 기준 만 7일 이내, 환불 및
                    결제 취소가 가능합니다.
                    <br />
                    <br />
                    - 충전 이후 유상/추가로 지급된 포인트를 사용한 내역이 없는
                    경우 &gt; 결제 취소 환불 가능.
                    <br />
                    <br />
                    - 유상 충전 금액 총합의 60% 이상이 사용된 경우 &gt; 부분
                    환불 가능.
                    <br />
                    <br />
                    환불/결제 취소 신청 시 추가로 지급된 이벤트 포인트는
                    소멸되며, 이미 사용했을 경우 해당 금액 만큼 차감되어 환불이
                    진행됩니다.
                    <br />
                    <br />
                    환불 신청은 고객센터를 이용해 주세요.
                  </div>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="program-more" onClick={_more}>
          결제내역 자세히 보기
        </div>
        <div className="program-home" onClick={_goHome}>
          처음으로
        </div>
      </div>
    </>
  );
};

export default shopContext(withRouter(WidgetPointOrderList));
